import { IconWithText } from 'common/icon/icon-with-text.js';
import * as React from 'react';
import { predicateNumber } from 'utilities/isType.js';
import { getBBQRatingClass, getBBQRatingTextClass } from './bbq-utils.js';
import { IBBQMapKey, IDynamicMapKeyContent } from './marker.type.bbq.js';

const LabelEl = ({ rating, label }: { rating?: number; label: string }) => {
  if (predicateNumber(rating) && rating > 0) {
    const labelClass = rating > 0 ? '' : 'u-textUppercase';
    const bbqRatingClass = getBBQRatingTextClass(rating);
    return (
      <small className="fineprint u-textBold u-block u-text-sm">
        <span className="u-mR-xs u-text-xs">RATING:</span>
        <span className={`${bbqRatingClass} ${labelClass}`}>{label}</span>
      </small>
    );
  }
  return (
    <small className="fineprint u-textBold u-block u-text-sm">
      <span className={`u-mR-xs u-text-xs ${getBBQRatingTextClass()}`}>NO RATING INFO</span>
    </small>
  );
};

function BBQLegendInner(keyContent: IDynamicMapKeyContent, idx: number): JSX.Element {
  const { rating, label, value } = keyContent;
  const bbqRatingClass = getBBQRatingClass(rating);
  const bbqRatingSVgClass = `${bbqRatingClass} Pill--currentColor`;

  return (
    <React.Fragment key={idx}>
      <IconWithText
        v={2}
        icon='bbq'
        iconClass={bbqRatingSVgClass}
        classes="IconWithText--small IconWithText--vCenter"
      >
        <LabelEl rating={rating} label={label} />
      </IconWithText>

      {value && <p className="fineprint u-mT-0">{value}</p>}
    </React.Fragment>
  );
}

/** Displays BBQ Key Element */
export const BBQLegend = ({ mapKey: { content } }: { mapKey: IBBQMapKey }) => (
  <div data-comp="generic-legend">{content?.map((keyContent, index) => BBQLegendInner(keyContent, index))}</div>
);
